<template>
  <div>
    <vx-card >
      <div class="vx-row mb-6">
        <div class="vx-col xxl:w-3/4 w-full">
          <p>Consulta y descarga los últimos estados de cuenta de RedGirasol en los que encontrarás
            tus movimientos, inversiones y más información relevante sobre tu participación en la Red.
            Ante cualquier duda o comentario estaremos para apoyarte a través del chat de la plataforma.</p>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-tabs v-model="activeTab" color="#28DE18" alignment="fixed" class="tab-action-btn-fill-container">
            <vs-tab label="Estados de cuenta">
              <div class="vx-row mb-6">
                  <div class="vx-col xxl:w-3/4 w-full">
                    <!-- <p><span class="bold">¡No olvides tener a la mano tu Segundo Factor de Autenticación!</span></p> -->
                    <p class="mt-2">
                      Consulta y descarga los últimos estados de cuenta de RedGirasol en los que encontrarás
                      tus movimientos, inversiones y más información relevante sobre tu participación en la Red.
                      Ante cualquier duda o comentario estaremos para apoyarte a través del chat de la plataforma.</p>
                  </div>
              </div>
              <vs-table ref="table" class="mt-6" :data="statements" pagination stripe :max-items="itemsPerPage" noDataText="No hay datos disponibles">
                <template slot="thead">
                  <vs-th class="bold" sort-key="month">MES</vs-th>
                  <vs-th class="bold">PERIODO</vs-th>
                  <vs-th class="bold">PDF</vs-th>
                  <vs-th class="bold">XML</vs-th>
                </template>

                <template slot-scope="{data}">
                  <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <p class="pl-3 bold">{{ tr.month }} {{tr.year}}</p>
                    </vs-td>
                    <vs-td>
                      <p class="font-medium truncate">{{ tr.start_period }} al {{tr.end_period}}</p>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <vs-button type="line" class="px-2 py-1" @click.stop="downloadPdf(tr)" disabled color="dark" >Descargar</vs-button>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <vs-button v-if="tr.has_xml" type="line" class="px-2 py-1" @click.stop="downloadXml(tr)" disabled color="dark" >Descargar</vs-button>
                      <p v-else>--</p>
                    </vs-td>

                  </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </vs-tab>
            <vs-tab label="Resumen de retenciones">
              <div class="vx-row mb-6">
                  <div class="vx-col xxl:w-3/4 w-full">
                    <!-- <p><span class="bold">¡No olvides tener a la mano tu Segundo Factor de Autenticación!</span></p> -->
                    <p class="mt-2">
                      En esta sección puedes consultar el resumen de la información de las retenciones realizadas por algunos Solicitantes relacionadas a los proyectos que invertiste.
                    </p>
                  </div>
              </div>
              <vs-row>
                <vs-col vs-lg="2" vs-sm="6" vs-xs="12">
                    <vs-select
                        class="w-full mb-4"
                        label="Año"
                        v-model.lazy="retainersYearSelected"
                        name="retainersYearSelected"
                        placeholder="Seleccione una opción"
                    >
                        <vs-select-item
                        :key="index"
                        :value="index"
                        :text="item"
                        v-for="(item,index) in years"
                        class="w-full"
                        />
                    </vs-select>
                </vs-col>
                <vs-col vs-lg="7" vs-sm="12" vs-xs="12" class="ml-4">
                    <div class="flex flex-wrap mt-6">
                        <vs-button color="success" @click="getRetainers()">Consultar</vs-button>
                    </div>
                </vs-col>
              </vs-row>
              <vs-table ref="table" class="mt-6" :data="retainers" pagination stripe :max-items="itemsPerPage" noDataText="No hay datos disponibles">
                <template slot="thead">
                  <vs-th class="bold" sort-key="month">RFC RETENEDOR</vs-th>
                  <vs-th class="bold">MONTO DEL INGRESO RECIBIDO</vs-th>
                  <vs-th class="bold">ISR RETENIDO</vs-th>
                </template>
                <template slot-scope="{data}">
                  <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <p class="bold">{{ tr.rfc }}</p>
                    </vs-td>
                    <vs-td>
                      <p class="font-medium truncate">{{ explicitMoneyFormat(tr.amount) }} </p>
                    </vs-td>
                    <vs-td>
                      <p class="font-medium truncate">{{ explicitMoneyFormat(tr.isr) }} </p>
                    </vs-td>
                  </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </vs-tab>
            <vs-tab label="Facturas de intereses">
              <div class="vx-row mb-6">
                  <div class="vx-col xxl:w-3/4 w-full">
                    <!-- <p><span class="bold">¡No olvides tener a la mano tu Segundo Factor de Autenticación!</span></p> -->
                    <p class="mt-2">
                      Consulta y descarga las facturas de intereses mas recientes, ante cualquier duda o comentario estaremos para apoyarte a través del chat de la plataforma.</p>
                  </div>
              </div>
              <vs-row>
                <vs-col vs-lg="2" vs-sm="6" vs-xs="12">
                    <vs-select
                        class="w-full mb-4"
                        label="Mes"
                        v-model.lazy="invoicesMonthSelected"
                        name="invoicesMonthSelected"
                        placeholder="Seleccione una opción"
                    >
                        <vs-select-item
                        :key="index"
                        :value="index+1"
                        :text="item"
                        v-for="(item,index) in months"
                        class="w-full"
                        />
                    </vs-select>
                </vs-col>
                <vs-col vs-lg="2" vs-sm="6" vs-xs="12" class="ml-2">
                    <vs-select
                        class="w-full mb-4"
                        label="Año"
                        v-model.lazy="invoicesYearSelected"
                        name="invoicesYearSelected"
                        placeholder="Seleccione una opción"
                    >
                        <vs-select-item
                        :key="index"
                        :value="index"
                        :text="item"
                        v-for="(item,index) in years"
                        class="w-full"
                        />
                    </vs-select>
                </vs-col>
                <vs-col vs-lg="7" vs-sm="12" vs-xs="12" class="ml-4">
                    <div class="flex flex-wrap mt-6">
                        <vs-button color="success" @click="getInvoicesAvailable()">Consultar</vs-button>
                    </div>
                </vs-col>
              </vs-row>
              <vs-table ref="table" class="mt-6" :data="groupedInvoices" pagination stripe :max-items="itemsPerPage" noDataText="No hay datos disponibles">
                <template slot="thead">
                  <vs-th>MES</vs-th>
                  <vs-th>FACTURAS</vs-th>
                  <vs-th>INTERESES COBRADOS</vs-th>
                  <vs-th>IVA</vs-th>
                  <vs-th>IVA RETENIDO</vs-th>
                  <vs-th>ISR RETENIDO</vs-th>
                  <vs-th>RESUMEN</vs-th>
                  <vs-th></vs-th>
                </template>
                <template v-if="groupedInvoices.length > 0" slot-scope="{data}">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>{{tr.date}}</vs-td>
                      <vs-td>{{tr.total}}</vs-td>
                      <vs-td>{{tr.interests}}</vs-td>
                      <vs-td>{{tr.tax}}</vs-td>
                      <vs-td>{{tr.tax_retention}}</vs-td>
                      <vs-td>{{tr.isr_retention}}</vs-td>
                      <vs-td>
                        <vs-button type="line" class="px-2 py-1" @click.stop="downloadResume(tr)" color="dark" >Descargar</vs-button>
                      </vs-td>
                      <vs-td></vs-td>
                      <template slot="expand">
                        <vs-table class="w-full text-center" :data="invoices(tr.date)" noDataText="No hay registros disponibles">
                          <template slot="thead">
                            <vs-th></vs-th>
                            <!-- <vs-th class="bold">FECHA</vs-th> -->
                            <vs-th class="bold">ID PROYECTO(S)</vs-th>
                            <vs-th class="bold">INTERESES</vs-th>
                            <vs-th class="bold">IVA</vs-th>
                            <vs-th class="bold">IVA RETENIDO</vs-th>
                            <vs-th class="bold">ISR RETENIDO</vs-th>
                            <vs-th class="bold">PDF</vs-th>
                            <vs-th class="bold">XML</vs-th>
                          </template>
                          <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tri, indextr) in data">
                              <vs-td></vs-td>
                              <!-- <vs-td class="text-left">{{tri.invoice_date}}</vs-td> -->
                              <vs-td class="text-left">{{tri.project_ids}}</vs-td>
                              <vs-td class="text-left">{{explicitMoneyFormat(tri.interests)}}</vs-td>
                              <vs-td class="text-left">{{explicitMoneyFormat(tri.tax)}}</vs-td>
                              <vs-td class="text-left">{{explicitMoneyFormat(tri.tax_retention)}}</vs-td>
                              <vs-td class="text-left">{{explicitMoneyFormat(tri.isr_retention)}}</vs-td>
                              <vs-td class="text-left">
                                <vs-button v-if="tri.pdf_file" type="line" class="px-2 py-1" @click.stop="downloadPdfInvoice(tri)" disabled color="dark" >Descargar</vs-button>
                              </vs-td>
                              <vs-td class="text-left">
                                <vs-button v-if="tri.xml_file" type="line" class="px-2 py-1" @click.stop="downloadXmlInvoice(tri)" disabled color="dark" >Descargar</vs-button>
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </template>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </vs-tab>
        </vs-tabs>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
import moment from 'moment';

export default {
  name: "StatementsPage",
  props: {
    InvestorId: {
      type: [String,Number],
      required: true
    },
  },
  data() {
    return {
      activeTab: 0,
      selected: [],
      allStatements: [],
      statements: [],
      allRetainers: [],
      retainers: [],
      allInvoices: [],
      groupedInvoices: [],
      itemsPerPage: 10,
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      isMounted: false,
      currentStatement: null,
      currentInvoice: null,
      authAction: null,
      factorEnabled: false,
      years: ["2020","2021","2022","2023","2024"],
      months: ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
      retainersYearSelected: 0,
      invoicesYearSelected: 0,
      invoicesMonthSelected: 1,
    }
  },
  mixins: [dateHelper, formatHelper],
  mounted () {
    this.isMounted = true
  },
  async beforeMount(){
    this.showLoading(true)
    await this.getStatementsAvailable();
    this.showLoading(false)
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  methods: {
    async getStatementsAvailable(){
      try {
        const res = await axios.get(`api/v2/investor/${this.InvestorId}/getStatements`);
        this.allStatements = res.data.statements;
        this.allStatements.forEach(f => {
          this.statements.push({
            id: f.id,
            month: this.monthName(f.end_period_month),
            year: f.end_period_year,
            start_period: this.regularDateFormat(f.start_period_date),
            end_period: this.regularDateFormat(f.end_period_date),
            has_xml: f.rg_invoice_id != null
          })
        });
      }
      catch (e) {
      }
    },
    async getRetainers(){
      this.allRetainers = [];
      this.retainers = [];
      this.showLoading(true);
       try {
         let year = this.years[this.retainersYearSelected];
         const res = await axios.get(`api/v2/investor/${this.InvestorId}/getRetainers/${year}`);
         this.allRetainers = res.data.retainers;
         this.allRetainers.forEach(f => {
           this.retainers.push({
             rfc: f.issuer_rfc,
             amount: f.amount,
             isr: f.isr
           })
         });
         this.showLoading(false);
       }
       catch (e) {
        this.showLoading(false);
       }
     },
     async getInvoicesAvailable(){
      this.allInvoices = [];
      this.groupedInvoices = [];
      this.showLoading(true);
       try {
          let month = this.invoicesMonthSelected;
          let year = this.years[this.invoicesYearSelected];
          const res = await axios.get(`api/v2/investor/${this.InvestorId}/getInvoices/${month}/${year}`);
          this.allInvoices = res.data.invoices;
          this.allInvoices.forEach(f => {
            f.invoice_date = this.regularDateFormat(f.date);
            f.date = this.incomeSpecial(f.date);
          });
          this.groupInvoices();
          this.showLoading(false);
       }
       catch (e) {
        console.log(e);
        this.showLoading(false);
       }
     },
     groupInvoices(){
      this.groupedInvoices = [];
      let groups = [];
      let group = {};
      this.allInvoices.forEach(invoice => {
          if (groups.filter(g => g.date === invoice.date).length == 0) {
            var dataGroup = this.invoicesAmounts(invoice.date);
            group = this.createGroup(invoice.date,dataGroup.interests,dataGroup.tax,dataGroup.tax_retention,dataGroup.isr_retention,dataGroup.count);
            groups.push(group);
          }
          this.groupedInvoices = groups; 
      });
    },
    createGroup(date,interests,tax,tax_retention,isr_retention,total){
      return {
        date: date,
        interests: this.explicitMoneyFormat(interests),
        tax: this.explicitMoneyFormat(tax),
        tax_retention: this.explicitMoneyFormat(tax_retention),
        isr_retention: this.explicitMoneyFormat(isr_retention),
        total: total,
      };
    },
    invoicesAmounts(date) {
      let data = {
        count:0,
        interests:0,
        tax:0,
        tax_retention:0,
        isr_retention:0
      };
      this.allInvoices.filter(inv => inv.date === date).forEach(inv => {
        data.count +=1;
        data.interests += inv.interests;
        data.tax += inv.tax;
        data.tax_retention += inv.tax_retention;
        data.isr_retention += inv.isr_retention;
      });
      return data;
    },
    invoices(date) {
        return this.allInvoices
            .filter(inv => inv.date === date)
            .map(inv => inv);
    },
    monthName(index){
      return this.monthNames[index -1];
    },
    async downloadPdf(tr){
      this.currentStatement = tr;
      await this.doDownloadPdf();
    },
    async downloadXml(tr){
      this.currentStatement = tr;
      await this.doDownloadXml();
    },
    async doDownloadPdf(){
      try {
        let url = `${this.ApiDomain}/api/v2/investor/${this.InvestorId}/adminDownloadStatementPdf/${this.currentStatement.id}?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      }
      catch (e) {
        this.warn(e)
        this.showError(e);
      }
    },
    async doDownloadXml(){
      try {
        let url = `${this.ApiDomain}/api/v2/investor/${this.InvestorId}/adminDownloadStatementXml/${this.currentStatement.id}?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      }
      catch (e) {
        this.warn(e)
        this.showError(e);
      }
    },
    async downloadResume(statement) {
      try {
        let year = moment(statement.start_period).year();
        let month = moment(statement.start_period).format("M");

        let url = `${this.ApiDomain}/api/v2/investor/${this.InvestorId}/adminDownloadStatementResume/${month}/${year}?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      }
      catch (e) {
        this.warn(e)
        this.showError(e);
      }
    },
    async downloadPdfInvoice(tr){
      if(!this.factorEnabled){
        this.$vs.dialog({
          color: "warning",
          type: "confirm",
          title: "Autenticación necesaria",
          text: "Para realizar esta operación es necesario habilitar tu Segundo Factor de Autenticación.",
          acceptText: "Habilitar",
          cancelText: 'Cancelar',
          accept: this.goTo2FaPage,
        });
        return;
      }
       this.currentInvoice = tr;
       this.authAction = 3;
       this.request2faCode();
    },
    async downloadXmlInvoice(tr){
      if(!this.factorEnabled){
        this.$vs.dialog({
          color: "warning",
          type: "confirm",
          title: "Autenticación necesaria",
          text: "Para realizar esta operación es necesario habilitar tu Segundo Factor de Autenticación.",
          acceptText: "Habilitar",
          cancelText: 'Cancelar',
          accept: this.goTo2FaPage,
        });
        return;
      }
      this.currentInvoice = tr;
      this.authAction = 4;
      this.request2faCode();
    },
    async goTo2FaPage(){
      await this.$router.push({name: 'auth2FaInversionista'});
    },
    showError(e){
      let err = "Ha ocurrido un error, intenta más tarde.";
      if(e.response && e.response.data && e.response.data.message){
        err = e.response.data.message;
      }
      this.errorNotifDialog('Error en la petición', err);
    },
  }
}
</script>
